<template>
    <div class="directory-item" v-for="(item, index) in nowDirectory" :key="index"
        @click="handleJumpPage(item.pageIndex, $event)">
        <div class="page-item-container">
            <div class="page-item"
                :style="{ 'margin-left': layer * 1 + 'em', 'width': 'calc( 100% - ' + (1 + layer) + 'em)' }">
                <div class="page-name">{{ item.pageName }}</div>
                <div class="page-number">{{ directoryContent[item.pageIndex].pageName }}</div>
            </div>
        </div>
        <directory-item :directoryList="item.child" :directoryContent="directoryContent"
            :layer="layer + 1"></directory-item>
    </div>
</template>

<script>
import { store } from "../store";

export default {
    name: "DirectoryItem",
    data: function () {
        return {
            store
        }
    },
    props: {
        directoryList: Array,
        directoryContent: Object,
        layer: Number
    },
    computed: {
        nowDirectory() {
            let arr = this.directoryList.filter(item => {
                return item.child != null && item.child.length > 0;
            })
            return arr
        }
    },
    methods: {
        handleJumpPage(pageIndex, event) {
            event.stopPropagation();
            window.pageControl.gotoPage(pageIndex, store.nowDirectoryTag);
        }
    }
}
</script>
<style src="../css/directory_item.css" scoped >

</style>
<style scoped>
.page-item {
    display: grid;
    grid-template-columns: 70% 30%;
    grid-column-start: 2;
    grid-column-end: 2;
    border-radius: 0.5rem;
    align-items: center;
    /* border-bottom: 1px solid black;
    color: black; */
}

.page-item:hover {
    color: black;
}

.page-number {
    font-size: 1.5rem;
    text-align: end;
    padding-right: 0.5rem;
}
</style>